'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypicalResponseTime = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTypicalResponseTime = exports.getTypicalResponseTime = (0, _get2.default)('typicalResponseTime');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/availability/operators/getTypicalResponseTime.js
// module id = 392
// module chunks = 2 3